/** @file Deletes keys of one timeline (key channel, deform, drawOrder or event) at frames, or all of them. */
import { z } from 'zod';
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { timelineKeys } from './timelineKeys';

/** animation.deleteKeys: empty timelines are pruned; no match is an INFO and leaves the document untouched. */
export const command = defineCommand({
  name: 'animation.deleteKeys',
  description: 'Delete the keys of one timeline at `frames` (all of its keys when omitted): a key channel or deform needs `target`; drawOrder takes none; event takes an optional event `target`.',
  input: z
    .object({
      animation: z.string().min(1),
      target: z.string().min(1).exactOptional(),
      channel: timelineKeys.channel,
      frames: z.array(prim.frame).min(1).exactOptional(),
    })
    .strict(),
  apply(draft, input, ctx) {
    const ref = timelineKeys.resolve(draft, input, ctx);
    const drop = new Set(input.frames ?? ref.keys.map((k) => k.f));
    const kept = ref.keys.filter((k) => !drop.has(k.f));
    if (kept.length === ref.keys.length) {
      ctx.warnings.push({ code: 'INFO', message: 'no keys matched; nothing was deleted', path: 'frames' });
      return;
    }
    ref.write(kept);
    draft.meta.updatedAt = ctx.now;
  },
});
